/* =========================================
   FC — PhotoSwipe thumbnail bar below the photo
   The thumbnail bar (.fc-pswp-thumbs, built in
   snippets/product-media.liquid) is absolutely
   positioned at the bottom of the lightbox and
   used to cover the photo (and the USP texts in
   it). This reserves the bar's height as bottom
   padding of the photo area, so the photo ends
   where the bar starts. Applies to all media.
   Re-hooks after variant-triggered lightbox
   rebuilds via polling (same approach as the bar).
   ========================================= */
(function () {
  'use strict';

  function hook(gallery) {
    var lb = gallery.lightbox;
    if (!lb || lb.__fcBarPadHooked) return;
    lb.__fcBarPadHooked = true;

    lb.on('afterInit', function () {
      var pswp = lb.pswp;
      if (!pswp || !pswp.element) return;

      /* Read the live bar height on every layout pass (resize, rotate). */
      pswp.options.paddingFn = function () {
        var bar = pswp.element.querySelector('.fc-pswp-thumbs');
        return { top: 0, right: 0, left: 0, bottom: bar ? bar.offsetHeight : 0 };
      };
      pswp.updateSize(true);

      /* The opening animation keeps the old size of the first slide;
         re-fit once it has finished (and once more as a fallback). */
      pswp.on('openingAnimationEnd', function () {
        pswp.updateSize(true);
      });
      setTimeout(function () {
        if (lb.pswp === pswp) pswp.updateSize(true);
      }, 600);
    });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      hook(gallery);
      setInterval(function () {
        if (gallery.lightbox) hook(gallery);
      }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
